'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _resizeShopifyImageUrl2 = require('../helpers/resize-shopify-image-url');

var _resizeShopifyImageUrl3 = _interopRequireDefault(_resizeShopifyImageUrl2);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

var _vuex = require('vuex');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Cart Item - Vue Component
---
Used as an inline-template within our app instance.
Holds local state for the cart item functionality and enables interacting with the vuex store.
----------------------------*/

_vue2.default.component('cart-item', {
  props: {
    item: Object
  },
  data: function data() {
    return {
      quantity: this.item.quantity,
      feedbackMessage: '',
      subscription: {},
      loading: false
    };
  },

  mounted: function mounted() {},
  methods: Object.assign({}, (0, _vuex.mapActions)('cart', ['removeCartItem', 'changeCartItem']), {

    // Change Quantity

    changeQuantity: function changeQuantity(newQuantity) {
      var _this = this;

      this.loading = true;

      // Normalize the quantity so users can't input negative numbers or decimals.
      newQuantity = Math.max(Math.round(newQuantity), 1);

      this.changeCartItem({
        id: this.item.key,
        quantity: Number(newQuantity)
      }).then(function () {
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        // On error show the error message under the cart item.
        _this.feedbackMessage = error;
        window.setTimeout(function () {
          _this.feedbackMessage = '';
        }, 3000);
      });
    },


    // Format Money

    formatMoney: function formatMoney(price) {
      return currency.formatMoney(price);
    },


    // Resize Shopify Image URL

    resizeShopifyImageUrl: function resizeShopifyImageUrl(url, size) {
      return (0, _resizeShopifyImageUrl3.default)(url, size);
    }
  }),
  computed: {
    // Is subscription product
    isSubscriptionProduct: function isSubscriptionProduct() {
      return this.item.properties && this.item.properties.subscription_id ? true : false;
    },

    // Product URL
    productUrl: function productUrl() {
      // If this is a subscription product then return the url of the original (not duplicate) product.
      if (this.isSubscriptionProduct) {
        return '/products/' + this.item.properties._subscription_original_product;
      }
      // Else return the url of the actual product.
      else {
          return this.item.url;
        }
    }
  },
  watch: {
    // Watch for item quantity changes and set them in local state.
    // Need to watch because the main item itself won't be reactive if it is already in the cart. We need to react to its deep property for quantity.
    item: {
      handler: function handler(val) {
        this.quantity = val.quantity;
      },
      deep: true
    }
  }
});